import { ComponentType } from '@angular/cdk/portal';
import { InjectionToken } from '@angular/core';

export const SPLIT_VISIT_DIALOG_COMPONENT = new InjectionToken<ComponentType<unknown>>('Split visit dialog component');
export const VISIT_RULES_DIALOG_COMPONENT = new InjectionToken<ComponentType<unknown>>('Visit rules dialog component');
export const PROVIDERS_DIALOG_COMPONENT = new InjectionToken<ComponentType<unknown>>('Providers dialog component');
export const LOCATIONS_DIALOG_COMPONENT = new InjectionToken<ComponentType<unknown>>('Locations dialog component');
